module.exports = __webpack_public_path__ + "static/media/logo.b92fc462.png";